import { TextFilter, HistoricalComboAthlete, CountryCombo } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { FiltersAbstractService } from 'src/app/common-page-components/classes/filters-abstract-service';
import { combineLatest } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class FiltersofficialsService extends FiltersAbstractService {
    constructor(http) {
        super();
        this.http = http;
        this.textFilter = new TextFilter('text');
        this.activeCombo = new HistoricalComboAthlete('Status:', 'currentcombo', undefined, [{ item: { Name: 'All', Value: undefined }, position: 0 }, { item: { Name: 'Current', Value: true },
                position: 1 }, { item: { Name: 'Historical', Value: false } }]);
        this.countryCombo = new CountryCombo('Country:', 'country-combo', this.http, [{ item: { CShort: 'All' }, position: 0 }], 'country', true, true);
        this.yesNotCombo = new HistoricalComboAthlete('World Archery only:', 'currentcombo', undefined, [{ item: { Name: 'Yes', Value: true },
                position: 1 }, { item: { Name: 'No', Value: false } }]);
        /**
         * Filters of officials service
         *
         * @memberof FiltersofficialsService
         */
        this.filtersType = [
            this.textFilter.filterInfo,
            this.countryCombo.filterInfo,
            this.activeCombo.filterInfo,
            this.yesNotCombo.filterInfo
        ];
    }
    generateDefaultValues() {
    }
    /**
     * Filter data of officials service
     *
     * @returns
     * @memberof FiltersofficialsService
     */
    getDataStreamWithFilters() {
        return combineLatest([
            this.orderSubject,
            this.textFilter.data(),
            this.activeCombo.comboData,
            this.countryCombo.comboData.pipe(filter(a => a != undefined)),
            this.yesNotCombo.comboData
        ]);
    }
}
FiltersofficialsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FiltersofficialsService_Factory() { return new FiltersofficialsService(i0.ɵɵinject(i1.HttpClient)); }, token: FiltersofficialsService, providedIn: "root" });
